import { api } from '@/contexts/AuthContext';

const track = async (eventType, metadata = {}) => {
  try {
    await api.post('/track', { event_type: eventType, metadata });
  } catch {}
};

export const trackPageView = (page) => track('page_view', { page });
export const trackSearch = (query, category) => track('search', { query, category });
export const trackProduceView = (postId, title) => track('produce_view', { post_id: postId, title });
export const trackContactClick = (farmerId, farmerName) => track('contact_click', { farmer_id: farmerId, farmer_name: farmerName });
export const trackSave = (postId, saved) => track('save', { post_id: postId, saved });
export const trackLogin = (method) => track('login', { method });
export const trackKYCSubmit = () => track('kyc_submit', {});
export const trackProduceCreate = (postId, title) => track('produce_create', { post_id: postId, title });
export const trackInstallPrompt = (action) => track('install_prompt', { action });

export default track;
